/**
 * @param {string} id
 * @returns string
 */
const convertIdToAbsoluteUrn = id => `urn:dm:schemas:${id}`
/**
 *
 * @param {string} urn
 * @returns {boolean}
 */
const isAbsoluteUrn = (/** @type {string} */ urn) => urn.startsWith('urn:')

/**
 * @param {string} ref
 * @returns {boolean}
 */
const isRelativeReference = ref => ref.startsWith('#/')

/**
 * @param {string} urn
 * @returns {object}
 */
const extractNamespaceFromAbsoluteUrn = urn => {
    const urnMatch = urn.match(/^urn:dm:schemas:([^#]+)#\/(.+)$/)
    if (urnMatch) {
        return {namespace: urnMatch[1], dataType: urnMatch[2].split('/')}
    }
    throw new Error(`Invalid URN absolute reference "${urn}"`)
}

/**
 * @param {string} ref
 * @returns {string[]}
 */
const extractPathFromRelativeReference = ref => ref.substring(2).split('/')

module.exports = {
    convertIdToAbsoluteUrn,
    isAbsoluteUrn,
    isRelativeReference,
    extractNamespaceFromAbsoluteUrn,
    extractPathFromRelativeReference
}
